import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';
import { DashboardsDisplayGridRowDataFragmentGql } from './DashboardsDisplayGridRowFragmentGql';

export const DatabaseDownstreamDashboardsFilteredByTableQueryGql: DocumentNode = gql`
query DatabaseDownstreamDashboardsFilteredByTableQuery($tableId: ID!, $first: Int!, $offset: Int!, $orderBy: DashboardSortOrder!) {
  tables(filter: { id: $tableId }) {
    downstreamDashboardsConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...DashboardsDisplayGridRowDataFragment
      }
    }
  }
}
${DashboardsDisplayGridRowDataFragmentGql}
`;
